<template>
  <v-layout>
    <v-flex xs12 NewEditDeleteDialog>
      <v-dialog v-model="dialog" persistent :fullscreen="!$vuetify.breakpoint.md && !$vuetify.breakpoint.lg" max-width="1400">
        <v-card :loading="loading" v-if="!deleting">
          <v-card-title :class="`font-weight-bold`" style="font-size:22px;">
            <v-toolbar
              color="primary"
              dark
              absolute
              dense>
              <div>{{ resourceSettings.resourceName  + ' | ' }}
                <span class="font-weight-light">{{ newResource.id ? 'edit' : 'add' }}</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn  flat @click.native="closeDialog()" >
                <v-icon class="hidden-md-and-up">close</v-icon>
                <span class="hidden-sm-and-down">cancel</span>
              </v-btn>
              <v-btn 
                v-if="!newResource.id && !loading"
                :disabled="!validate(newResource) || loading"
                flat @click.native="postResource(newResource)" 
              >
                <v-icon class="hidden-md-and-up">save</v-icon>
                <span class="hidden-sm-and-down">save</span>
              </v-btn>
              <v-btn 
                  v-if="newResource.id  && !loading"
                  :disabled="!validate(newResource) || loading"
                  flat @click.native="updateResource(newResource)" 
                >
                <v-icon class="hidden-md-and-up">save</v-icon>
                <span class="hidden-sm-and-down">update</span>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-layout row wrap>
              <v-flex xs12 my-2 style="text-transform:uppercase;font-weight:bold;">
                General
              </v-flex>
              <v-flex xs12 md4 py-0 px-1 v-for="(field, k) in resourceKeys.filter(field=>field.type != 'editor')" :key="'key-' + k">
                <v-text-field
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  :readonly="((field.label == 'sku' ||  field.label == 'slug') && newResource.id ? true : false) || field.disabled"
                  :disabled="((field.label == 'sku' ||  field.label == 'slug') && newResource.id ? true : false) || field.disabled"
                  v-if="field.type == 'text' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  dense
                  @input="field.label == 'sku' ||  field.label == 'slug'? checkUnique() : null"
                  outline
                  :counter="field.max?true:false"
                  :maxlength="field.max"
                  v-model.trim="newResource[field.name]"
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-textarea
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  outline
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  v-if="field.type == 'textarea' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  dense
                  v-model="newResource[field.name]"
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-textarea>
                <v-text-field
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  outline
                  v-if="field.type == 'number' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  dense
                  @keypress="isNumber($event)"
                  v-model="newResource[field.name]"
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-autocomplete
                  :items="field.data"
                  v-model="newResource[field.name]"
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  clearable
                  :multiple="field.multiple"
                  autocomplete="disabled"
                  v-if="field.type == 'select' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  outline
                  dense
                  :item-value="`${field.name}_id`"
                  
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-autocomplete>
                <v-switch 
                  v-if="field.type == 'switch' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  :name="getNameID()"
                  :id="getNameID()"
                  :label="field.label" 
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  color="primary"
                  dense
                  :hint="`${field.info && field.info.en ? field.info.en : ''}`"
                  :persistent-hint="field.info && field.info.en ? true : false"
                  v-model="newResource[field.name]"
                >
                  
                </v-switch>
                <v-menu
                  v-model="datepicker[field.name]"
                  :close-on-content-click="false"
                  v-if="field.type == 'date' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="field.label"
                      :name="getNameID()"
                      :id="getNameID()"
                      outline
                      :disabled="field.readonly"
                      v-if="field.type == 'date' && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                      autocomplete="disabled"
                      dense
                      v-model="newResource[field.name]"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template slot="append">
                        <v-tooltip top>
                          <template slot="activator">
                            <v-icon size="18" color="primary">help</v-icon>
                          </template>
                          {{field.info.en}}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newResource[field.name]"
                    @input="datepicker[field.name] = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  :readonly="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  :disabled="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  v-if="field.type == 'upload' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  dense
                  outline
                  v-model.trim="newResource[field.name]"
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="fileImages"
                  accept="csv/*"
                  @change="onFilePickedImages"
                  v-if="field.type == 'upload'"
                >
                <v-btn v-if="field.type == 'upload'" color="primary" block @click="pickFileImages(field.name)">add image</v-btn>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12 md6 py-0 px-1 v-for="(field, k) in resourceKeys.filter(field=>field.type == 'editor')" :key="'key2-' + k">
                    <v-expansion-panel focusable v-if="field.type == 'editor'">
                      <v-expansion-panel-content>
                        <div slot="header">{{field.label}}</div>
                        <v-card>
                          <v-card-text>
                            <vue-editor 
                              ref="editorV" 
                              v-if="field.type == 'editor' 
                              && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                              || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                              == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                              v-model="newResource[field.name]">
                            </vue-editor>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.prices">
                <v-layout row wrap>
                  <pricesPanel
                    :prices="newResource.prices"
                    :resource="resource"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                  />
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.vprices">
                <v-layout row wrap>
                  <vpricesPanel
                    :prices="newResource.vprices"
                    :resource="resource"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                  />
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.accounts">
                <v-layout row wrap>
                  <usersProductPanel
                    :accounts="newResource.accounts"
                    :resource="resource"
                    @removeAccount="removeAccount"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                  />
                </v-layout>
              </v-flex>
              
              <v-flex xs12 v-if="newResource.variants">
                <v-layout row wrap>
                  <variantsPanel
                    :variants="newResource.variants"
                    :resource="resource"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                    @newVariant="newVariant"
                    @removeVariant="removeVariant"
                  />
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.vendorsubs">
                <v-layout row wrap>
                  <vSubsPanel
                    :vendorsubs="newResource.vendorsubs"
                    :resource="resource"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                    @newVendorSub="newVendorSub"
                    @removeVendorSub="removeVendorSub"
                  />
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.products">
                <v-layout row wrap align-center>
                  <v-flex xs12>
                    <draggable v-model="newResource.products" style="width:100%">
                      <transition-group style="width:100%">
                        <v-layout v-for="(product, p) in newResource.products" :key="'product-drag-' + p " align-center>
                          <v-flex xs12>
                            <v-layout row wrap align-center py-1>
                              <v-flex xs1 px-1>
                                <v-icon>drag_handle</v-icon>
                              </v-flex>
                              <v-flex xs3 px-1>
                                <v-autocomplete
                                  :items="resource.products"
                                  v-model="product.product_id"
                                  label="Product"
                                  item-text="sku"
                                  item-value="id"
                                  outline
                                  hide-details
                                  dense
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs5 px-1>
                                <v-autocomplete
                                  :items="resource.countries"
                                  v-model="product.countries"
                                  label="Countries"
                                  item-text="name"
                                  item-value="id"
                                  outline
                                  multiple
                                  hide-details
                                  dense
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs2 px-1>
                                <v-img
                                  on="on"
                                  v-if="product.product_id 
                                  && resource.products.filter(x=>x.id == product.product_id)[0]
                                  && resource.products.filter(x=>x.id == product.product_id)[0].image 
                                  && resource.products.filter(x=>x.id == product.product_id)[0].image.url"
                                  class="elevation-2 my-1"
                                  :src="resource.products.filter(x=>x.id == product.product_id)[0].image.url"
                                  height="60px"
                                ></v-img>
                              </v-flex>
                              <v-flex xs1 px-1 class="text-xs-center">
                                <v-btn color="error" flat icon @click="removeItem(p)">
                                  <v-icon>close</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </transition-group>
                    </draggable>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="primary" @click="addProduct()"> add product</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.sections">
                <v-layout row wrap align-center>
                  <v-flex xs12>
                    <draggable v-model="newResource.sections" style="width:100%">
                      <transition-group style="width:100%">
                        <v-layout v-for="(section, p) in newResource.sections" :key="'section-drag-' + p " align-center>
                          <v-flex xs12>
                            <v-layout row wrap align-center py-1>
                              <v-flex xs1 px-1>
                                <v-icon>drag_handle</v-icon>
                              </v-flex>
                              <v-flex xs10 px-1>
                                <v-textarea
                                  v-model="section.body"
                                  label="Body"
                                  outline
                                  hide-details
                                  dense
                                ></v-textarea>
                              </v-flex>
                              <v-flex xs1 px-1 class="text-xs-center">
                                <v-btn color="error" flat icon @click="removeSection(p)">
                                  <v-icon>close</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </transition-group>
                    </draggable>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="primary" @click="addSection()"> add section</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="newResource.images">
                <v-layout row wrap>
                  <imagesPanel
                    :images="newResource.images"
                    :resource="resource"
                    :resourceSettings="resourceSettings"
                    :loading="loading"
                    @newImage="newImage"
                    @removeImage="removeImage"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click.native="closeDialog()" >cancel</v-btn>
            <v-btn 
              color="success" 
              v-if="!newResource.id && !loading"
              :disabled="!validate(newResource) || loading"
              flat @click.native="postResource(newResource)" 
              
            >submit</v-btn>
            <v-btn 
                color="success" 
                v-if="newResource.id && !loading"
                :disabled="!validate(newResource)  || loading"
                flat @click.native="updateResource(newResource)" 
                
              >update</v-btn>
          </v-card-actions>
        </v-card>
        <v-card :loading="loading" v-if="deleting">
          <v-card-title :class="`font-weight-bold`" style="font-size:22px;">
            <div>{{ resourceSettings.resourceName  + ' | ' }}<span class="font-weight-light">delete</span></div>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex cols="12" md="12" class="pa-5 error white--text">
                {{ newResource.name }}
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click.native="closeDialog()" >cancel</v-btn>
            <v-btn 
                color="error" 
                v-if="newResource.id"
                flat @click.native="deleteResource(newResource)" 
                :disabled="loading"
              >delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { firebase, store, db, auth, storageRef } from '@/fb';
import draggable from 'vuedraggable'
import pricesPanel from '@/components/pricesPanel'
import vpricesPanel from '@/components/vpricesPanel'
import imagesPanel from '@/components/imagesPanel'
import variantsPanel from '@/components/variantsPanel'
import usersProductPanel from '@/components/usersProductPanel'
import vSubsPanel from '@/components/vSubsPanel'

import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {
    VueEditor, pricesPanel, imagesPanel, variantsPanel, draggable, vpricesPanel, usersProductPanel, vSubsPanel
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings', 'resource'],
  data(){
    return {
      rules: {
        required: value => !!value || 'required',
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'valid_email'
      },
      datepicker:{},
      timepicker:{},
      menu:{},
      uploadFiled:null,
      uploadProgress:null,
      file:null,
      name:null,
      uploadURL:null,
      error:false,
    }
  },
  methods: {
    async checkUnique() {
      console.log(this.newResource.sku)
      console.log(this.resourceSettings.resourceName)
      let name = this.resourceSettings.resourceName
      let a
      if(name == 'products') {
        a = await axios.get(`${this.api}/sku/${this.newResource.sku}`).then(x=>x.data)
      } else if(name == 'landing-pages') {
        a = await axios.get(`${this.api}/lslug/${this.newResource.slug}`).then(x=>x.data)
      } else {
        a = await axios.get(`${this.api}/sslug/${this.newResource.slug}`).then(x=>x.data)
      }
      console.log(a)
      if(!a.status) {
        this.error = true
        this.$emit('snackbarNotification', `DUPLICATE`, 'error')
      } else {
        this.error = false
      }
    },
    removeItem(p) {
      this.newResource.products.splice(p, 1)
    },
    removeSection(p) {
      this.newResource.sections.splice(p, 1)
    },
    addProduct(){
      this.newResource.products.push({})
    },
    addSection(){
      this.newResource.sections.push({})
    },
    newVariant(variant){
      this.newResource.variants.push(variant)
    },
    
    async removeVariant(variant){
      await axios.delete(`${this.api}/variants/${variant.id}`).then(x=>x.data)
      this.newResource.variants.splice(this.newResource.variants.findIndex(x=>x.id == variant.id), 1)
    },
    async newVendorSub(vendorsub){
      let sku = await axios.get('https://us-central1-ashyaatcrm.cloudfunctions.net/gensku/genSKU/subvendor').then(x=>`K.00${x.data.next_sku}`)
      vendorsub.sku = sku
      this.newResource.vendorsubs.push(vendorsub)
    },
    async removeVendorSub(vendorsub){
      await axios.delete(`${this.api}/vendorsubs/${vendorsub.id}`).then(x=>x.data)
      this.newResource.vendorsubs.splice(this.newResource.vendorsubs.findIndex(x=>x.id == vendorsub.id), 1)
    },
    newImage(image){
      this.newResource.images.push(image)
    },
    async removeImage(image){
      await axios.delete(`${this.api}/images/${image.id}`).then(x=>x.data)
      this.newResource.images.splice(this.newResource.images.findIndex(x=>x.id == image.id), 1)
      if(this.newResource.images.length > 0 && !this.newResource.images.filter(x=>x.default).length) {
        this.newResource.images[0].default = true
      }
    },
    async removeAccount(account){
      await axios.delete(`${this.api}/rmvupr/${account.id}`).then(x=>x.data)
      this.newResource.accounts.splice(this.newResource.accounts.findIndex(x=>x.id == account.id), 1)
    },
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${x.name} required`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `Not valid email`, 'error')
        }
      })
      if(this.error) {
        v = false
      }
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    },
    pickFileImages(name){
      this.uploadFiled = name
      this.$refs.fileImages[0].click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = 0
          this.$emit('getUpload', {field:this.uploadFiled, value:downloadURL} )
          console.log(downloadURL)
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>